import { Paper, Typography } from "@mui/material";
import WebsiteActionTable from "./WebsiteActionsElements/WebsiteActionTable/WebsiteActionTable";
import Grid from "@mui/material/Grid2";
import WebsiteActionFilterCard from "./WebsiteActionsElements/WebsiteActionFilterCard/WebsiteActionFilterCard";
import { useEffect, useState } from "react";
import { websiteActionEndPointLogic } from "../../../../logic/AssetManagement/Websites/websiteActionEndPointLogic";
import {
  selectUserData,
  selectUserDetails,
  selectUserToken,
  selectUserWebsitePermissions,
} from "../../../../features/userSlice";
import { useSelector } from "react-redux";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import Page404 from "../../../Page404/Page403";
import { useLocation, useNavigate } from "react-router-dom";
import SimpleBackdrop from "../../../BackDrop/BackDrop";

function WebsiteActions() {
  const [websiteList, setWebsiteList] = useState([]);
  const tableHeadings = {
    ui_site_name: "Site Name",
    site_type: "Type",
    territories__territory_name: "Territory",
    industries__industry_name: "Industry",
    is_active: "Status",
    sync_enabled: "Sync",
    timezone: "Time Zone",
    last_edited: "Last Edited",
    last_edited_by: "Edited By",
    quick_actions: "Quick Actions",
    more_info: "More info",
  };

  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const [loading, setLoading] = useState(true);
  const [reloadTable, setReloadTable] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const userDetails = useSelector(selectUserDetails) as any;
  const isSuperUser = userDetails?.superuser ?? false;
  const websitePermissions = useSelector(selectUserWebsitePermissions) as any;

  const webSiteIds = websitePermissions?.map(
    (item: any) => Object.keys(item)[0]
  ); // Get Websites Ids

  //-- Get User Permissions for Websites
  const response = useSelector(selectUserData);
  const hasViewWebsiteListPermission = CheckPermissions(
    response?.data?.products?.assets,
    "websites",
    "view_websites_list"
  );

  //-- Get All Websites
  useEffect(() => {
    (async () => {
      setLoading(true);
      await websiteActionEndPointLogic.getAllWebsites(
        oauthTokenHeader,
        setWebsiteList
      );
      setLoading(false);
      setReloadTable(false);
    })();
    //eslint-disable-next-line
  }, [oauthTokenHeader, reloadTable === true]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (params.has("websiteSharedUid")) {
      params.delete("websiteSharedUid");
      navigate({ search: params.toString() }, { replace: true });
    }
  }, [location, navigate]);

  // Filter Websites for Regular Users
  useEffect(() => {
    if (!isSuperUser && websiteList.length > 0 && webSiteIds.length > 0) {
      const matchedWebsites = websiteList.filter((item: any) =>
        webSiteIds.includes(item.shared_uid)
      );
      setWebsiteList(matchedWebsites); // Creating a new array for immutability
    }
    // eslint-disable-next-line
  }, [isSuperUser === false, websiteList?.length, webSiteIds?.length]);

  return (
    <>
      {hasViewWebsiteListPermission ? (
        <>
          {loading ? (
            <SimpleBackdrop />
          ) : (
            <Paper sx={{ padding: "8px 16px" }}>
              <Grid container alignItems="center" sx={{ mb: 2 }}>
                <Grid size={8}>
                  <Typography variant="h3" sx={{ fontSize: "24px" }}>
                    Websites
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: "14px" }}>
                    Create new or edit existing websites.
                  </Typography>
                </Grid>
              </Grid>
              <WebsiteActionFilterCard
                websiteList={websiteList}
                setReloadTable={setReloadTable}
              />
              <WebsiteActionTable
                tableHeadings={tableHeadings}
                websiteList={websiteList}
                webSiteIds={webSiteIds}
              />
            </Paper>
          )}
        </>
      ) : (
        <Page404 />
      )}
    </>
  );
}

export default WebsiteActions;
